/* eslint-disable */
"use strict";

import ODToggle from "./../../components/toggle.js";
import ODLayoutStickyCard from "./sticky-card.js";
import ODLayoutHeaderMenu from "./header-menu.js";
import ODLayoutAsideMenu from "./aside-menu.js";
import { ODCookie } from "./../../components/cookie.js";
import { ODUtil } from "./../../components/util.js";

var ODLayoutAsideToggle = function() {
    // Private properties
    var _body;
    var _element;
    var _toggleObject;

	// Initialize
	var _init = function() {
		_toggleObject = new ODToggle(_element, _body, {
			targetState: 'aside-minimize',
			toggleState: ''
		});

		_toggleObject.on('toggle', function(toggle) {
            // Update sticky card
            if (typeof ODLayoutStickyCard !== 'undefined') {
                ODLayoutStickyCard.update();
            }

            // Pause header menu dropdowns
            if (typeof ODLayoutHeaderMenu !== 'undefined') {
                ODLayoutHeaderMenu.pauseDropdownHover(800);
            }

            // Pause aside menu dropdowns
            if (typeof ODLayoutAsideMenu !== 'undefined') {
                ODLayoutAsideMenu.pauseDropdownHover(800);
            }

            // Remember state in cookie. One week Max-Age
			ODCookie.setCookie('aside_toggle_state', toggle.getState(), {SameSite : 'Lax', 'Max-Age' : 2629743});
			// to set default minimized left aside use this cookie value in your
			// server side code and add "kt-primary--minimize aside-minimize" classes to
			// the body tag in order to initialize the minimized left aside mode during page loading.
		});

		_toggleObject.on('beforeToggle', function(toggle) {
			if (ODUtil.hasClass(_body, 'aside-minimize') === false && ODUtil.hasClass(_body, 'aside-minimize-hover')) {
				ODUtil.removeClass(_body, 'aside-minimize-hover');
			}
		});
	}

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);
            _body = ODUtil.getBody();

            if (!_element) {
                return;
            }

            // Initialize
            _init();
		},

        getElement: function() {
            return _element;
        },

        getToggle: function() {
			return _toggleObject;
		},

		onToggle: function(handler) {
			if (typeof _toggleObject.element !== 'undefined') {
				_toggleObject.on('toggle', handler);
			}
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutAsideToggle;
}

export default ODLayoutAsideToggle;
